import type { CSSProperties } from "react";
import { useTranslation } from "react-i18next";

// The chores Psihotron takes over, in the order one client passes through a
// practice: from being found to the money arriving. Every line gets struck
// out; the last line, the conversation itself, is the only one that stays.
const CHORES = [
  "finding",
  "scheduling",
  "reminders",
  "video",
  "payment",
  "vat",
  "documents",
  "payout",
] as const;

/**
 * A to-do list being crossed off. The client's hero shows a deck of themes;
 * this one shows the therapist's desk emptying, one line at a time, until
 * only therapy is left on it.
 */
export function HeroDesk() {
  const { t } = useTranslation();

  return (
    <div
      className="animate-hero-rise mt-14 max-w-2xl"
      style={{ animationDelay: "420ms" }}
    >
      <p
        className="text-sm font-medium sm:text-base"
        style={{ color: "color-mix(in oklab, var(--color-paper) 75%, transparent)" }}
      >
        {t("forTherapists.hero.desk.prompt")}
      </p>

      <ul className="mt-4 grid gap-x-10 gap-y-2 text-[15px] leading-snug sm:grid-cols-2 sm:text-base">
        {CHORES.map((key, i) => (
          <li
            key={key}
            className="ther-strike"
            style={{ "--strike-index": i } as CSSProperties}
          >
            {t(`forTherapists.hero.desk.items.${key}`)}
          </li>
        ))}
      </ul>

      <p
        className="ther-keep font-heading mt-5 text-lg font-bold sm:text-xl"
        style={{ "--strike-index": CHORES.length } as CSSProperties}
      >
        <span style={{ color: "var(--color-ther-sage)" }}>
          {t("forTherapists.hero.desk.keep")}
        </span>{" "}
        <span
          className="font-medium"
          style={{ color: "color-mix(in oklab, var(--color-paper) 70%, transparent)" }}
        >
          {t("forTherapists.hero.desk.keepNote")}
        </span>
      </p>
    </div>
  );
}
